import { AttributeSelector } from "./AttributeSelector/AttributeSelector";
//import { ColorSelector } from "./Color/Color";
import { ColorSelector } from "./ColorSelector/ColorSelector";

export const FeatureTypes = {
  color: ColorSelector,
  attribute: AttributeSelector,
};
